import { WizardFormBuilder } from "@CommonLib/src/frontend/WizardForm/Builder/WizardFormBuilder";
import type { WizardFormConfig } from "@CommonLib/src/frontend/WizardForm/types";
import { Box } from "@mui/material";
import { useInput } from "react-admin";

interface WizardFormBuilderInputProps {
	source: string;
}

export const WizardFormBuilderInput = ({
	source,
}: WizardFormBuilderInputProps) => {
	const {
		field: { value, onChange },
	} = useInput<WizardFormConfig>({ source });

	const handleConfigChange = (newConfig: WizardFormConfig) => {
		// react-hook-form expects raw value here
		onChange(newConfig);
	};

	if (!value) return null;

	return (
		<Box sx={{ width: "100%" }}>
			<WizardFormBuilder config={value} onConfigChange={handleConfigChange} />
		</Box>
	);
};
